import { G, Path } from 'react-native-svg';
import * as React from 'react';
import withIcon from '../../../src/components/iconly/withIcon';

type Props = {
  opacity?: string;
  color?: string;
  secondaryColor?: string;
  set?: string;
  strokeWidth?: string | number;
};

const Star = ({ color, secondaryColor, strokeWidth, opacity, set }: Props) => {
  const Bold = () => (
    <G transform="translate(2 2.5)">
      <Path
        d="M15.919,11.82a1.1,1.1,0,0,0-.319.97l.889,4.92a1.08,1.08,0,0,1-.45,1.08,1.1,1.1,0,0,1-1.17.08L10.44,16.56a1.131,1.131,0,0,0-.5-.131H9.669a.812.812,0,0,0-.27.09L4.969,18.84a1.168,1.168,0,0,1-.71.11,1.112,1.112,0,0,1-.89-1.271l.89-4.92a1.119,1.119,0,0,0-.319-.979L.329,8.28A1.08,1.08,0,0,1,.06,7.15,1.123,1.123,0,0,1,.949,6.4l4.97-.721A1.112,1.112,0,0,0,6.8,5.07L8.989.58a1.041,1.041,0,0,1,.2-.27l.09-.07A.671.671,0,0,1,9.44.11L9.549.07,9.719,0h.421a1.119,1.119,0,0,1,.88.6l2.219,4.47a1.111,1.111,0,0,0,.83.609l4.97.721a1.134,1.134,0,0,1,.91.75,1.086,1.086,0,0,1-.29,1.13Z"
        transform="translate(0 0)"
        fill={color}
      />
    </G>
  );
  const Bulk = () => (
    <G transform="translate(2 2.5)">
      <Path
        d="M10.976.614,13.2,5.088a1.112,1.112,0,0,0,.838.6l5,.728a1.121,1.121,0,0,1,.736.43,1.082,1.082,0,0,1,.21.815,1.112,1.112,0,0,1-.321.632l-3.624,3.513a1.056,1.056,0,0,0-.321.963l.892,4.939a1.115,1.115,0,0,1-.892,1.272,1.168,1.168,0,0,1-.714-.114l-4.461-2.324a1.169,1.169,0,0,0-1.053,0L5.033,18.866A1.143,1.143,0,0,1,3.5,18.419a1.131,1.131,0,0,1-.116-.7l.892-4.94a1.061,1.061,0,0,0-.321-.964L.332,8.3A1.084,1.084,0,0,1,.3,6.772l.029-.029a1.078,1.078,0,0,1,.642-.315l5-.729a1.114,1.114,0,0,0,.838-.6L8.96.614A1.107,1.107,0,0,1,9.977,0h.134a1.116,1.116,0,0,1,.865.613"
        fill={secondaryColor}
        opacity={opacity}
      />
      <Path
        d="M9.992,16.417a1.226,1.226,0,0,0-.552.151L5,18.887a1.158,1.158,0,0,1-1.5-.461,1.106,1.106,0,0,1-.116-.694L4.274,12.8a1.1,1.1,0,0,0-.321-.975L.328,8.318A1.093,1.093,0,0,1,.311,6.774l.017-.016A1.134,1.134,0,0,1,.96,6.441L5.965,5.7A1.083,1.083,0,0,0,6.8,5.1L8.978.563A1.106,1.106,0,0,1,10,0c-.008.3-.008,16.213-.008,16.415"
        fill={color}
      />
    </G>
  );
  const Light = () => (
    <G transform="translate(2.5 3)">
      <Path
        d="M10.214.441,12.53,5.1a.8.8,0,0,0,.6.437l5.185.749a.8.8,0,0,1,.528.306.77.77,0,0,1-.085,1.032L15,11.258a.762.762,0,0,0-.226.7l.9,5.128a.787.787,0,0,1-.652.892.868.868,0,0,1-.516-.08L9.888,15.478a.776.776,0,0,0-.742,0L4.494,17.912a.812.812,0,0,1-1.077-.33.8.8,0,0,1-.081-.5l.9-5.128a.788.788,0,0,0-.226-.7L.232,7.621a.786.786,0,0,1,0-1.112l0,0a.909.909,0,0,1,.452-.222L5.87,5.534a.812.812,0,0,0,.6-.438L8.784.441a.787.787,0,0,1,.458-.4.8.8,0,0,1,.61.044A.82.82,0,0,1,10.214.441Z"
        transform="translate(0 0)"
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth={strokeWidth}
      />
    </G>
  );

  const Broken = () => (
    <G transform="translate(2 2)">
      <Path
        d="M15.5,19.919a.67.67,0,0,1-.352-.09l-5.138-2.706L5.484,19.559a1.521,1.521,0,0,1-2.062-.613l-.015-.028a1.64,1.64,0,0,1-.158-1l.88-5.194L.451,9a1.6,1.6,0,0,1,0-2.227,1.494,1.494,0,0,1,.88-.451l5.043-.766L8.617.883a1.515,1.515,0,0,1,2.754,0l2.253,4.689,5.06.775a1.525,1.525,0,0,1,1.016.624,1.649,1.649,0,0,1-.162,2.081l-3.661,3.68.51,2.8a.782.782,0,0,1-.625.9.758.758,0,0,1-.88-.613l-.519-2.8a1.623,1.623,0,0,1,.44-1.408l3.67-3.706-5.06-.785a1.52,1.52,0,0,1-1.153-.9L10.008,1.551,7.728,6.294a1.518,1.518,0,0,1-1.153.9L1.532,7.96l3.643,3.7a1.591,1.591,0,0,1,.44,1.389l-.88,5.194,4.523-2.426a1.472,1.472,0,0,1,1.443,0l5.131,2.706a.788.788,0,0,1,.387.879.77.77,0,0,1-.739.6Z"
        transform="translate(0 0)"
        fill={color}
      />
    </G>
  );

  const Curved = () => (
    <G transform="translate(3 3)">
      <Path
        d="M9,0C6.964,0,6.771,3.547,5.559,4.8S.578,4.62.055,6.844s2.868,2.98,3.286,4.889-1.651,4.591.119,5.926S7.134,15.975,9,15.975s3.771,3.019,5.541,1.685-.3-4.017.119-5.926,3.808-2.664,3.286-4.889-4.292-.791-5.5-2.044S11.036,0,9,0Z"
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth={strokeWidth}
      />
    </G>
  );

  switch (set) {
    case 'bold':
      return <Bold />;
    case 'bulk':
      return <Bulk />;
    case 'broken':
      return <Broken />;
    case 'curved':
      return <Curved />;
    default:
      return <Light />;
  }
};
Star.displayName = 'IconlyStar';

export default withIcon(Star);
